import React from 'react';
import { UserManagement } from './UserManagement';
import { AdminSutaBasesCard } from './AdminSutaBasesCard';
import { AdminSutaRatesCard } from './AdminSutaRatesCard';
import { AdminWcRatesCard } from './AdminWcRatesCard';

export function AdminPage({
  // SUTA Bases
  STATES,
  DEFAULT_SUTA_BASES,
  customSutaBases,
  setCustomSutaBases,
  sutaBases,
  sutaUploadInfo,
  sutaFileRef,
  handleSutaUpload,
  adminApi,
  // SUTA Rates
  sutaRates,
  sutaRatesDraft,
  sutaRatesSaved,
  startEditSutaRates,
  resetSutaRatesToDefaults,
  saveSutaRates,
  cancelEditSutaRates,
  updateDraftRate,
  // WC Rates
  wcRateTable,
  setWcRateTable,
  wcUploadInfo,
  wcFileRef,
  handleWcUpload,
  wcFilter,
  setWcFilter,
  filteredWcRates,
  wcIsCustom,
  flattenWcRates,
  DEFAULT_WC_RATES,
  WC_DESCRIPTIONS,
  WC_RISK_LABELS,
}) {
  return (
    <div className="space-y-8" data-testid="admin-page">
      <h1 className="text-2xl font-bold font-['Outfit'] text-slate-900">Administration</h1>

      {/* User Management */}
      <UserManagement />

      {/* SUTA Wage Bases */}
      <AdminSutaBasesCard
        STATES={STATES}
        DEFAULT_SUTA_BASES={DEFAULT_SUTA_BASES}
        customSutaBases={customSutaBases}
        setCustomSutaBases={setCustomSutaBases}
        sutaBases={sutaBases}
        sutaUploadInfo={sutaUploadInfo}
        sutaFileRef={sutaFileRef}
        handleSutaUpload={handleSutaUpload}
        adminApi={adminApi}
      />

      {/* SUTA Rate Table */}
      <AdminSutaRatesCard
        STATES={STATES}
        sutaRates={sutaRates}
        sutaRatesDraft={sutaRatesDraft}
        sutaRatesSaved={sutaRatesSaved}
        startEditSutaRates={startEditSutaRates}
        resetSutaRatesToDefaults={resetSutaRatesToDefaults}
        saveSutaRates={saveSutaRates}
        cancelEditSutaRates={cancelEditSutaRates}
        updateDraftRate={updateDraftRate}
      />

      {/* WC Rate Table */}
      <AdminWcRatesCard
        STATES={STATES}
        wcRateTable={wcRateTable}
        setWcRateTable={setWcRateTable}
        wcUploadInfo={wcUploadInfo}
        wcFileRef={wcFileRef}
        handleWcUpload={handleWcUpload}
        wcFilter={wcFilter}
        setWcFilter={setWcFilter}
        filteredWcRates={filteredWcRates}
        wcIsCustom={wcIsCustom}
        flattenWcRates={flattenWcRates}
        DEFAULT_WC_RATES={DEFAULT_WC_RATES}
        WC_DESCRIPTIONS={WC_DESCRIPTIONS}
        WC_RISK_LABELS={WC_RISK_LABELS}
      />
    </div>
  );
}
